module.exports = __webpack_public_path__ + "img/foundationIllustrationGenericError@3x.f80ca3f9.png";